import { apiRequest } from "@/lib/api";

export type PublicPlatformSettings = {
  platform_name: string;
  support_email: string;
  support_whatsapp: string;
  support_hours: string;
  whatsapp_message: string;
  initial_trial_enabled: boolean;
  initial_trial_plan_name: string | null;
  initial_trial_days: number;
};

export async function getPublicPlatformSettings():
  Promise<PublicPlatformSettings> {
  return apiRequest<PublicPlatformSettings>(
    "/platform-admin/settings/public/",
    {
      method: "GET",
    },
  );
}
